import { render, staticRenderFns } from "./NewOrExistingUser.vue?vue&type=template&id=8f995f70&scoped=true"
import script from "./NewOrExistingUser.vue?vue&type=script&lang=js"
export * from "./NewOrExistingUser.vue?vue&type=script&lang=js"
import style0 from "./NewOrExistingUser.vue?vue&type=style&index=0&id=8f995f70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f995f70",
  null
  
)

export default component.exports